import { render } from "./RegionValue.vue?vue&type=template&id=26d3416e"
import script from "./RegionValue.vue?vue&type=script&lang=js"
export * from "./RegionValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__